export default __webpack_public_path__ + "static/media/RegisterBadge.c17d484f.svg";